import { useRef } from "react";
import PdfUploader from "@/components/admin/PdfUploader";
import PdfList from "@/components/admin/PdfList";

const PdfUploadPage = () => {
  const pdfListRef = useRef<{ refresh: () => void }>(null);

  const handleUploadSuccess = () => {
    if (pdfListRef.current?.refresh) {
      pdfListRef.current.refresh();
    }
  };

  return (
    <div className="space-y-8">
      <h1 className="text-3xl font-bold text-primary">PDF Dokumentumok Kezelése</h1>
      <PdfUploader onUploadSuccess={handleUploadSuccess} />
      <PdfList ref={pdfListRef} />
    </div>
  );
};

export default PdfUploadPage;